import { DefaultPrimaryButton, DefaultSecondaryButton } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { UserSelectV2 } from '@frontend/user/select';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

export interface UpdateBackupUserModalProps {
    entity_id: string;
    currentBackupUserId: string | null;
    onUpdate: (newUserId: string | null) => Promise<void>;
    isSaving: boolean;
}

export const UpdateBackupUserModal = (props: UpdateBackupUserModalProps) => {
    const [selectedUserId, setSelectedUserId] = useState<string | null>(props.currentBackupUserId);

    useEffect(() => {
        setSelectedUserId(props.currentBackupUserId);
    }, [props.currentBackupUserId]);

    const handleSubmit = async () => {
        await props.onUpdate(selectedUserId);
    };

    const handleClear = () => {
        setSelectedUserId(null);
    };

    return (
        <div className='flex flex-col gap-6 p-6'>
            <div className='flex flex-col gap-2'>
                <h2 className='text-xl font-semibold'>
                    <FormattedMessage
                        id='update-backup-user-modal.title'
                        defaultMessage='Update Backup Notification User'
                    />
                </h2>
                <p className='text-foreground-muted text-sm'>
                    <FormattedMessage
                        id='update-backup-user-modal.description'
                        defaultMessage='Select a user who should receive backup notifications when this user is unable to pick up parcels.'
                    />
                </p>
            </div>

            <div className='flex flex-col gap-4'>
                <UserSelectV2
                    value={selectedUserId || undefined}
                    onChange={(val) => setSelectedUserId(val || null)}
                    disabled={props.isSaving}
                    key={selectedUserId}
                />
            </div>

            <div className='flex justify-end gap-3'>
                {selectedUserId && (
                    <DefaultSecondaryButton
                        onClick={handleClear}
                        text={
                            <FormattedMessage
                                id='update-backup-user-modal.clear'
                                defaultMessage='Clear'
                            />
                        }
                        disabled={props.isSaving}
                    />
                )}
                <DefaultPrimaryButton
                    onClick={handleSubmit}
                    text={CommonMessage.BUTTONS.SUBMIT}
                    disabled={props.isSaving || selectedUserId === props.currentBackupUserId}
                    isLoading={props.isSaving}
                />
            </div>
        </div>
    );
};
